import SiemensHealthineersLogoFull from './healthineers_navbar.png'; // Adjust the path as necessary


const LogoFull = () => {
  return <img src={SiemensHealthineersLogoFull} alt="Company Logo" />;
};

export default LogoFull;
